/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TaskClasses {
    UserDefined = 0,
    ConventionalBogging = 2,
    RemoteBogging = 3,
    Drilling = 4,
    Misfire = 5,
    Strip = 6,
    DidNotFire = 7,
    Fire = 8,
    Wait = 9,
    Charge = 10,
}
